import React, { useContext } from 'react';
import { IVideosContext, VideosContext } from '../../../videosState/videosContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, videos } = useContext<IVideosContext>(VideosContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={videos.videosCount ? 800 : undefined}
		/>
	);
};

export default Search;
